import { createFileRoute } from "@tanstack/react-router";
import { ManageRequestsRoute } from "src/containers/ManageRequestsRoute";

export const Route = createFileRoute("/_layout-nosidebar/manageRequests")({
    component: ManageRequests,
});

export default function ManageRequests() {
    return <ManageRequestsRoute />;
}
